import AbstractTextFormatter from './AbstractTextFormatter'

export default class TimeFormatter extends AbstractTextFormatter {
  // @ts-expect-error
  internalFormat(matches: any) {
    if (matches && matches.length > 0) {
      const date = new Date(Date.parse(matches[1]))

      return date.toLocaleTimeString()
    }
  }
}
